/**
 * created by lei lei on 2020/6/12
 * 图标统计
 * 新增图片放到img 然后引用进来，
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Card, Avatar, Popconfirm, Icon} from 'antd';
import  weChat from './img/wechat.png'
import  microBlog from './img/microBlog.png'
import  tiktok from './img/tiktok.png'
import  notFiled from './img/notFiled.png'

const { Meta } = Card;
const customIcon=[{    //新增新图标放到img ，然后引入，自己加入枚举值。
    type:'notFiled',
    icon:notFiled
},{
    type:'weChat',
    icon:weChat
},{
    type:'microBlog',
    icon:microBlog
},{
    type:'tiktok',
    icon:tiktok
},]

export default class IconStatistic extends Component {
    static defaultProps = {
        iconType:'weChat',
        title:'标题',
        //numAll:30,
        mark:'(10活跃)',
        customWidthHeight:50,
        fontSizeTitle:14,
         showMore:false,
        background:'white'
    }
    static propTypes = {
        iconType:PropTypes.string.isRequired,// 图标类型必传项
        title:PropTypes.string.isRequired,//标题必传项
        numAll:PropTypes.number,//总计数非传项
        mark:PropTypes.string.isRequired,//描述必传项
        customWidthHeight:PropTypes.number,//图标的宽高大小一个字段可选字段
        fontSizeTitle:PropTypes.number,//标题字体大小可选字段可选字段
        showMore:PropTypes.bool,//是否显示更多可选字段非必传项
        onClickMore:PropTypes.func,//点击更多可选字段非必传项
        onClickFunction:PropTypes.func,//点击每一项非必传项
        background:PropTypes.string,//背景颜色，非必须项

    }

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let icon=weChat
        customIcon.forEach((item,i)=>{
            if(this.props.iconType===item.type){
                icon=item.icon
            }
        })
        return (
            <div className={'IconStatistic'}  style={{position:'relative',background:this.props.background, borderRadius: "5px"}}>
                <Card  style={{padding:15,width:210,height:130,background:this.props.background, borderRadius: "5px"}}>
                    {this.props.showMore?  <div onClick={()=>{
                    this.props.onClickMore&&this.props.onClickMore()
                    }
                        } style={{width:70,position:'absolute',right:0,cursor:'pointer',height:45,lineHeight:'45px',top:0,fontSize:14}}>
                               查看更多
                            </div>
                        :null}
                        <div onClick={()=>{
                            this.props.onClickFunction&&this.props.onClickFunction()
                        }}>
                            <Meta
                                avatar={<img style={{width:this.props.customWidthHeight,objectFit:'cover'}} src={icon} />}
                                title={<span style={{fontSize:14,color:this.props.color}}>{this.props.title}</span>}
                                description={<span><span style={{color:this.props.color}}>{this.props.numAll}</span>&nbsp;&nbsp;<span style={{fontSize:12,color:this.props.color}}>{this.props.mark}</span> </span>}
                            />
                        </div>

                </Card>
            </div>
        )
    }

}